import React from 'react'
import Forfait_Orange from './Forfait_Orange.png';
import Enveloppe_Data from './Enveloppe_Data.png';
import Forfait_bloqué from './Forfait_bloqué.png';
import SEO from '../../../../Hook/Seo';
import useCountUp from '../../../../Hook/useCountUp';
import AnimatedSection from '../../../../Hook/Block';
import './mobile.css'
import TarifsSection from '../../../../Hook/TarifSection';
import VideoPresentationTelephonie from '../../TelephonieVideo.mp4'
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';

// ==========================================================================
// DÉCLARATION DES ICÔNES SVG EN DATA URL (Intégrées directement pour le Mobile)
// ==========================================================================
// Icone pour les petits forfaits de départ (Connexion de base)
const ICON_SIGNAL_LOW   = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M23 3a1 1 0 0 0-1.045-.143l-21 8a1 1 0 0 0 .068 1.874l6.113 2.113 2.113 6.113a1 1 0 0 0 1.874.068l8-21A1 1 0 0 0 23 3z' /%3E%3C/svg%3E";
// Icone pour la Data intermédiaire (Réseau / Données mobiles)
const ICON_DATA_MEDIUM  = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M7 16V4m0 0L3 8m4-4l4 4m6 0v12m0 0l4-4m-4 4l-4-4' /%3E%3C/svg%3E";
// Icone pour les gros forfaits (Vitesse supérieure / Performance)
const ICON_DATA_HIGH    = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M13 10V3L4 14h7v7l9-11h-7z' /%3E%3C/svg%3E";
// Icone pour l'Europe, les voyages et le roaming mondial
const ICON_GLOBE_EUROPE = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Ccircle cx='12' cy='12' r='10'/%3E%3Cpath d='M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20M2 12h20'/%3E%3C/svg%3E";
// Icone Premium max (Couronne / Forfait Ultime sans compromis)
const ICON_PREMIUM_MAX  = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%234c5372' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M2 4l3 12h14l3-12-6 7-4-7-4 7-6-7z' /%3E%3C/svg%3E";

const Mobile = () => {
    const navigate = useNavigate()
    const [openTarifs, setOpenTarifs] = useState({ fixe: false, mobile: false });

    const clients1 = useCountUp(400, 2000);
    return (
        <>
            <SEO
                title="Téléphonie Mobile Forfais 4G / 5G  | AM Services dans les Vosges"
                description="Installation et gestion de forfais mobile 4g et 5g dans les Vosges."
                path="/mobile"
                keywords={["téléphonie IP", "VoIP PME", "standard", "SVI", "DECT", "Vosges", "Remiremont", "Épinal , Saint Etienne les Remiremonts , Val D'Ajol , Pouxeux , Arches  "]}
            />
            <div className="container">
                <div className="div_container">
                    <h1 className="sr-only">Téléphonie IP d’entreprise : standards, SVI et DECT dans les Vosges</h1>
                    <video
                        src={VideoPresentationTelephonie}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className="background-video"
                        aria-label="Vidéo de présentation des services AM Services"
                    />
                    <div className="info-hero-center-text">
                        <h1 className="info-title">TELEPHONE MOBILE</h1>
                        <p className="info-lead">
                            Chez AMServices, votre téléphonie professionnelle est simple, fluide et connectée.
                        </p>
                    </div>
                </div>
                
                <div id='mobile'>
                    <AnimatedSection
                        sectionTitle="Téléphonie Mobile"
                        direction="left"
                        items={[
                            { img: Forfait_Orange, alt: "Forfait Orange", title: "Forfait 100% Orange", text: "Forfait mobile sur le réseau d'Orange, pour une connexion stable." },
                            { img: Enveloppe_Data, alt: "Data Europe", title: "Enveloppe data Europe", text: "Le forfait est utilisable partout en Europe, Suisses et Royaume-Uni." },
                            { img: Forfait_bloqué, alt: "Forfait bloqué", title: "Forfait bloqué", text: "Maîtrise totale : le forfait data est garanti sans hors forfait." }
                        ]}
                        count={clients1}
                        countLabel="Clients satisfaits"
                    />
                </div>

                {/* === SECTION DE TARIFS RESTRUCTURÉE (Prise en charge automatique par mobile.css) === */}
                <TarifsSection
                    name="mobile"
                    label="les tarifs mobiles"
                    sectionTitle="Nos forfaits mobiles"
                    openTarifs={openTarifs}
                    setOpenTarifs={setOpenTarifs}
                    tarifs={[
                        { title: "Forfait Pro illimité 1GB", description: "Appels/SMS illimités et 1GB de data en Europe, Suisse et UK", price: "7,90€ HT/mois", icon: ICON_SIGNAL_LOW },
                        { title: "Forfait Pro illimité 3GB", description: "Appels/SMS illimités et 3GB de data en Europe, Suisse et UK", price: "9,90€ HT/mois", icon: ICON_SIGNAL_LOW },
                        { title: "Forfait Pro illimité 5GB", description: "Appels/SMS illimités et 5GB de data en Europe, Suisse et UK", price: "10,90€ HT/mois", icon: ICON_DATA_MEDIUM },
                        { title: "Forfait Pro illimité 10GB", description: "Appels/SMS illimités et 10GB de data en Europe, Suisse et UK", price: "12,90€ HT/mois", icon: ICON_DATA_MEDIUM },
                        { title: "Forfait Pro illimité 20GB", description: "Appels/SMS illimités et 20GB de data en Europe, Suisse et UK", price: "14,90€ HT/mois", icon: ICON_DATA_HIGH },
                        { title: "Forfait Pro illimité 50GB", description: "Appels/SMS illimités et 50GB de data en Europe, Suisse et UK", price: "19,90€ HT/mois", icon: ICON_DATA_HIGH },
                        { title: "Forfait Pro illimité 100GB", description: "Appels/SMS illimités et 100GB de data en Europe, Suisse et UK", price: "29,90€ HT/mois", icon: ICON_GLOBE_EUROPE },
                        { title: "Forfait Pro illimité 200GB", description: "Appels/SMS illimités et 200GB de data en Europe, Suisse et UK", price: "39,90€ HT/mois", icon: ICON_PREMIUM_MAX },
                    ]}
                />

                <div className='div_btn-telephones'>
                    <div className="btn-telephones" onClick={() => navigate("/telmobile")}>
                        Voir nos Téléphones
                    </div>
                </div>
            </div>
        </>
    )
}

export default Mobile;